import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

function dm_c_21_cards_scroll_horizontal() {
    const screenBreakpoint = 1199;
    if (window.innerWidth <= screenBreakpoint) return;

    const sections = document.querySelectorAll(".c-21-cards-scroll-horizontal");

    sections.forEach((section) => {
        const wrapper = section.querySelector(".soc-cards__track-wrapper");
        const track = section.querySelector(".soc-cards__track");
        const cards = gsap.utils.toArray(
            section.querySelectorAll(".soc-cards__card")
        );
        const tabs = gsap.utils.toArray(
            section.querySelectorAll(".soc-cards__tab")
        );

        if (!wrapper || !track || cards.length < 2) return;

        let currentIndex = 0;

        gsap.set(track, { x: 0 });
        gsap.set(cards, { opacity: (i) => (i === 0 ? 1 : 0.25) });

        function goToCard(index) {
            if (index === currentIndex) return;
            currentIndex = index;

            gsap.to(track, {
                x: -(wrapper.offsetWidth * index),
                duration: 0.6,
                ease: "power3.inOut",
                overwrite: true,
            });

            cards.forEach((card, i) => {
                gsap.to(card, {
                    opacity: i === index ? 1 : 0.25,
                    duration: 0.4,
                    ease: "power2.out",
                    overwrite: true,
                });
            });

            tabs.forEach((tab, i) => {
                tab.classList.toggle("is-active", i === index);
            });
        }

        tabs.forEach((tab, index) => {
            tab.addEventListener("click", () => goToCard(index));
        });

        ScrollTrigger.create({
            trigger: section,
            start: "top top",
            end: () => `+=${window.innerHeight * (cards.length - 1) * 1.8}`,
            pin: true,
            anticipatePin: 1,
            snap: {
                snapTo: 1 / (cards.length - 1),
                duration: { min: 0.3, max: 0.6 },
                ease: "power1.inOut",
            },
            onUpdate: (self) => {
                const newIndex = Math.min(
                    cards.length - 1,
                    Math.round(self.progress * (cards.length - 1))
                );
                goToCard(newIndex);
            },
        });
    });
}

export { dm_c_21_cards_scroll_horizontal };